<template>
  <div class="container">
    <h1>Termin Stornieren</h1>
    <div v-if="showConfirmation" class="confirmation">
      <p>Sind Sie sicher, dass Sie Ihren Termin stornieren möchten?</p>
      <button @click="confirmCancellation" class="btn btn-confirm">Ja, Stornieren</button>
      <button @click="cancel" class="btn btn-cancel">Nein, Zurück</button>
    </div>
    <div v-if="isProcessing" class="processing">
      <p>Ihre Anfrage wird bearbeitet...</p>
    </div>
    <div v-if="isCancelled" class="success">
      <p>Ihr Termin wurde erfolgreich storniert.</p>
      <button @click="goHome" class="btn btn-home">Zurück zur Startseite</button>
    </div>
    <div v-if="error" class="error">
      <p>Fehler: {{ error }}</p>
      <button @click="goHome" class="btn btn-home">Zurück zur Startseite</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: ['token', 'workerEmail'],
  data() {
    return {
      isProcessing: false,
      isCancelled: false,
      error: null,
      showConfirmation: true
    };
  },
  methods: {
    async confirmCancellation() {
      this.showConfirmation = false;
      this.isProcessing = true;

      try {
        if (!this.token || !this.workerEmail) {
          throw new Error('Token oder Arbeits-E-Mail fehlen');
        }
        const apiUrl = `${process.env.VUE_APP_API_URL}/request/cancel?token=${this.token}&worker_email=${this.workerEmail}`;
        const response = await axios.delete(apiUrl);

        if (response.status === 200) {
          this.isCancelled = true;
        } else {
          this.error = 'Der Termin konnte nicht storniert werden. Bitte versuchen Sie es später erneut.';
        }
      } catch (error) {
        this.error = error.response ? error.response.data.message : 'Fehler bei der Stornierung des Termins. Bitte überprüfen Sie Ihre Netzwerkverbindung.';
        console.error('Fehler bei der Stornierung des Termins:', error);
      } finally {
        this.isProcessing = false;
      }
    },
    cancel() {
      this.$router.push('/');
    },
    goHome() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 600px;
  margin: auto;
  padding: 20px;
  text-align: center;
}


h1 {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
}

.confirmation, .processing, .success, .error {
  text-align: center;
}

.confirmation p, .processing p, .success p, .error p {
  margin: 20px 0;
  font-size: 16px;
}

.btn {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  margin: 5px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s ease;
}

.btn:hover {
  background-color: #0056b3;
}

.btn-confirm {
  background-color: #28a745;
}

.btn-confirm:hover {
  background-color: #218838;
}

.btn-cancel {
  background-color: #dc3545;
}

.btn-cancel:hover {
  background-color: #c82333;
}

.btn-home {
  background-color: #007bff;
}

.btn-home:hover {
  background-color: #0056b3;
}

.success {
  color: #28a745;
}

.error {
  color: #dc3545;
}
</style>
